export default __webpack_public_path__ + "static/media/image-home.9411918d.png";